const { checkBotAndTypeForLogs } = require("../api/utils/botAndTypeDetector");

const queryParamsAgentSRP = (
  city,
  state_code,
  name,
  postalCode,
  addedCertifications,
  sorting,
  selectType,
) => {
  const query = {
    city,
    state_code,
    name,
    selectedType: selectType,
    postalCode,
    addedCertifications,
    sorting,
  };
  return query;
};

const getSecondPart = (str, s, n) => {
  return str && str.split(s)[n];
};
const slugExtraction = (qlocation) => {
  let isName = /name-/.test(qlocation);

  const isnum = /^\d+$/.test(qlocation);

  let state_code, county, city;
  const qlocationLength = qlocation && qlocation.split("_");
  if (qlocationLength && qlocationLength.length > 2 && /county/i.test(qlocation)) {
    state_code = !isName && !isnum ? getSecondPart(qlocation, "_", 2) : null;
    county = !isName && !isnum ? getSecondPart(qlocation, "_", 1) : null;
    city =
      !isName && !isnum
        ? getSecondPart(qlocation, "_", 0) && getSecondPart(qlocation, "_", 0).replace("-", " ")
        : null;
  } else if (qlocationLength && qlocationLength.length > 2 && !/county/i.test(qlocation)) {
    state_code = !isName && !isnum ? getSecondPart(qlocation, "_", 2) : null;
    city = !isName && !isnum ? getSecondPart(qlocation, "_", 1).replace(/-/gi, " ") : null;
    county =
      !isName && !isnum
        ? getSecondPart(qlocation, "_", 0) && getSecondPart(qlocation, "_", 0).replace(/-/gi, " ")
        : null;
  } else {
    state_code = !isName && !isnum ? getSecondPart(qlocation, "_", 1) : null;
    county = null;
    city =
      !isName && !isnum
        ? getSecondPart(qlocation, "_", 0) && getSecondPart(qlocation, "_", 0).replace("-", " ")
        : null;
  }

  let agentname = isName && !isnum ? getSecondPart(qlocation, "name-", 1) : null;

  agentname = agentname && agentname.replace(/-/g, " ");
  const postalCode = !isName && isnum ? qlocation : null;

  const result = {
    city,
    state_code,
    county,
    agentname,
    postalCode,
  };

  return result;
};

const globalSlugExtract = (slugParams) => {
  const qlocationArray = slugParams && slugParams.qlocation;
  const results = slugExtraction(qlocationArray);
  const slugParamsArray = slugParams && slugParams["0"].split("/").filter((m) => m !== "");
  const modifiedslugParamsArray = slugParamsArray.map((m) => {
    const marray = m.split("-");
    const marrayObj = {
      type: marray[0],
      value: marray[1],
    };
    return marrayObj;
  });

  const obj = {};
  modifiedslugParamsArray.forEach((m) => {
    if (m.type === "price") {
      const priceArray = m.value.split("_");
      const minPrice = priceArray[0];
      const maxPrice = priceArray[1];
      m.value = { minPrice, maxPrice };
    }
    if (m.type === "lang" || m.type === "designation") {
      m.value = m.value.replace(/;/g, "%2C");
    }
    if (m.type === "pg") {
      m.value = (parseInt(m.value) - 1) * 20;
    }
    obj[m.type] = m.value;
  });

  const FinalObj = { ...results, ...obj };

  const result = FinalObj;
  return result;
};
const getSortingMethod = (sortingType) => {
  const srpSortingMethods = {
    activity: "recent_activity_high",
    ratings: "agent_rating_high",
    recommendations: "recommendations_count_high",
    activelistings: "for_sale_count_high",
    sold: "recently_sold_high",
  };
  return srpSortingMethods[sortingType];
};

const getSortingOption = (sortingMethod) => {
  const srpSortingOption = {
    recent_activity_high: "activity",
    agent_rating_high: "ratings",
    recommendations_count_high: "recommendations",
    for_sale_count_high: "activelistings",
    recently_sold_high: "sold",
  };
  return srpSortingOption[sortingMethod];
};
const getSortingText = (sortingMethod) => {
  const srpSortingOption = {
    recent_activity_high: "Most Recent Activity",
    agent_rating_high: "Highest Ratings",
    recommendations_count_high: "Most Recommendations",
    for_sale_count_high: "Most For Sale Listings (All)",
    recently_sold_high: "Most Sold Listings (All)",
  };
  return srpSortingOption[sortingMethod];
};
const checkForRealtorProfile = (request) => {
  const hostname = request.hostname;
  const dotRealtorProfile = hostname.endsWith(".realtor");
  return dotRealtorProfile;
};
const generatedInvertedNrdsId = (nrds_id) => {
  let reverseNrdsId = "";
  // eslint-disable-next-line no-extra-boolean-cast
  if (!!nrds_id) {
    nrds_id
      .split("")
      .reverse()
      .map((number) => {
        reverseNrdsId += Math.abs(number - 9);
      });
  }
  return reverseNrdsId;
};

const checkDetailPageSlug = (qlocation, req) => {
  let isDetailPage;

  const arr = qlocation.split("_");
  const advertiser_id = arr[3];
  let nrds_id = arr[4];
  const pattern = /((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+[0-9a-z]+$/i;
  if (req && req.query && req.query.nrdsid) {
    nrds_id = req && req.query && req.query.nrdsid;
    isDetailPage = true;
  }

  if (!isNaN(nrds_id) || !isNaN(advertiser_id)) {
    isDetailPage = true;
  } else if (arr && arr.length === 1 && arr[0].match(pattern)) {
    isDetailPage = true;
  } else {
    isDetailPage = false;
  }

  return isDetailPage;
};

const checkshortURL = (qlocation) => {
  let advertiser_id, isshortURL;
  const advertiser_id_arr = qlocation && qlocation.split("___");
  const advertiserId = advertiser_id_arr && advertiser_id_arr[1];
  if (qlocation.startsWith("___") && !isNaN(advertiserId)) {
    advertiser_id = advertiserId;
    isshortURL = true;
  }
  const finalResult = {
    advertiser_id,
    isshortURL,
  };
  return finalResult;
};

const checkDetailPage = (qlocation) => {
  let isDetailPage;
  const testFAR = /realestateagents/.test(qlocation);
  const testFAR1 = /realtors/.test(qlocation);
  const arr = qlocation.split("_");
  const advertiser_id = arr[3];
  let nrds_id = arr[4];

  if (
    (!isNaN(nrds_id) && (testFAR || testFAR1)) ||
    (!isNaN(advertiser_id) && (testFAR || testFAR1))
  ) {
    isDetailPage = true;
  } else {
    isDetailPage = false;
  }

  return isDetailPage;
};
const covertLogsToJson = (logData) => {
  let lexStatus, cid, lexId, lexObject;
  const splitllogDataString = logData.split(' "');
  const userAgent =
    splitllogDataString &&
    splitllogDataString.length > 0 &&
    splitllogDataString[3].length > 30 &&
    splitllogDataString[3];

  const { isBot, deviceType, deviceSubType } =
    (userAgent && checkBotAndTypeForLogs(userAgent)) || {};
  let requestUserType = {
    isBot,
    deviceType,
    deviceSubType,
  };
  requestUserType = userAgent ? requestUserType : {};

  const splitlogString = logData.split(" ");
  let timestamp =
    splitlogString &&
    splitlogString[3] &&
    splitlogString[3].split("[")[1] + " " + splitlogString[4].split("]")[0];

  let method = splitlogString && splitlogString[5] && splitlogString[5].split(`"`)[1];
  let url = splitlogString && splitlogString[6] && splitlogString[6];
  let protocol = splitlogString && splitlogString[7] && splitlogString[7];
  let status = splitlogString && splitlogString[8] && splitlogString[8];
  let requested_uri = splitlogString && splitlogString[10] && splitlogString[10];
  const isDetailPage = checkDetailPage(requested_uri);
  //LEX object for creating alert
  if (requested_uri && requested_uri.length > 3 && isDetailPage) {
    cid = requested_uri && getParameterByName("cid", requested_uri);
    lexId = requested_uri && getParameterByName("lex_id", requested_uri);
    if (cid || lexId) {
      lexStatus = cid && lexId ? true : false;
      lexObject = {
        lexStatus,
        cid,
        lexId,
      };
    }
  }
  let systemType =
    splitlogString && splitlogString[14] && splitlogString[14].replace(/[^a-zA-Z ]/g, "");

  let browser =
    splitlogString &&
    splitlogString[splitlogString.length - 2] &&
    splitlogString[splitlogString.length - 2];
  let line = logData;
  let finalObj = {
    line,
    timestamp,
    method,
    url,
    protocol,
    status,
    requested_uri_http_method: "GET",
    requested_uri,
    systemType,
    browser,
    requestUserType,
    lexObject,
  };
  finalObj = JSON.stringify(finalObj);
  return finalObj;
};
const getCIDLexId = (query) => {
  const finalResult = {
    cid: query && query.cid,
    lex_id: query && query.lex_id,
    ...(query && query.mre_id && { mre_id: query && query.mre_id }),
    ...(query && query.origin_source && { origin_source: query && query.origin_source }),
  };
  return finalResult;
};
const getParameterByName = (name, url = {}) => {
  // eslint-disable-next-line no-useless-escape
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
module.exports = {
  getParameterByName,
  checkDetailPageSlug,
  slugExtraction,
  globalSlugExtract,
  getSecondPart,
  queryParamsAgentSRP,
  getSortingMethod,
  getSortingOption,
  getSortingText,
  checkForRealtorProfile,
  generatedInvertedNrdsId,
  checkshortURL,
  covertLogsToJson,
  getCIDLexId,
};
